var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemorialDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 41,
    viewBox: "0 0 16 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M4.802 3.126l.8-1.387c.117-.201-.029-.455-.263-.455h-1.6L3.084.153c-.117-.204-.41-.204-.526 0l-.654 1.13h-1.6c-.234 0-.38.255-.264.456l.801 1.387-.8 1.386c-.118.203.029.456.263.456h1.6L2.559 6.1c.116.203.409.203.526 0l.653-1.132H5.34c.234 0 .38-.253.263-.456l-.8-1.386z",
    transform: "translate(.84 .728)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M3.041 39.56H2.69c-.254 0-.46-.208-.46-.462V10.932c0-.255.206-.461.46-.461h.352c.255 0 .461.206.461.461v28.166c0 .254-.206.461-.46.461",
    transform: "translate(.84 .728)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.388 20.903c-3.16 1.931-5.567-1.458-9.864.506-.064.028-.106.093-.106.163v6.67c0 .123.124.205.24.161 4.499-1.687 6.56 1.387 9.913-.585.054-.033.09-.093.09-.156V21.05c0-.14-.154-.22-.273-.147",
    transform: "translate(.84 .728)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemorialDay);
export default __webpack_public_path__ + "static/media/memorialDay.cf99d4e17ef8cc4d99190ed09e519b4f.svg";
export { ForwardRef as ReactComponent };